import { TYPE_OBJECT } from '../domains/Template builder/const/templates';



export default (field) => field.type !== TYPE_OBJECT && field.use_in_preset;
